"use strict";

$.colorpicker.regional[$("html").attr("lang")] = {
    "ok":             t("photobook-js-buttonsOk"),
    "cancel":         t("photobook-js-buttonsCancel"),
    "none":           t("photobook-js-noColor"),
    "title":          t("photobook-js-selectColor"),
    "transparent":    t("photobook-js-transparent"),
};
